(function () {
  const ROOT_ID = 'mexzy-beauty-root';
  const RECO_PER_GROUP = 5;
  const SUGGEST_LIMIT = 10;
  const MAX_KEYWORDS_PER_GROUP = 16;
  const SCAN_GROUP_NAMES = [
    'easy', 'toner', 'day', 'night', 'treatment', 'eye', 'exec', 'neck', 'hair', 'body',
  ];
  const TAG_PREFIX = 'skinscan:';
  const TAG_EXCLUDE = 'skinscan:exclude';
  const TAG_ANY = 'skinscan:any';

  const SEARCH_KEYWORDS = {
    easy: [
      'cleanser', 'cleansing', 'wash', 'micellar', 'serum', 'essence', 'moistur', 'cream', 'lotion',
      'face oil', 'huile', 'balm', 'makeup remover', 'démaquillant',
    ],
    toner: ['toner', 'tonique', 'lotion tonique', 'mist', 'brume', 'essence water', 'prep'],
    day: [
      'spf', 'sunscreen', 'sun care', 'uv', 'vitamin c', 'brighten', 'day cream', 'fluid',
      'gel cream', 'antioxidant', 'pollution',
    ],
    night: [
      'retinol', 'retinoid', 'bakuchiol', 'peptide', 'night cream', 'repair', 'sleeping mask',
      'balm', 'exfol', 'aha', 'bha', 'peel', 'glycolic', 'lactic', 'oil',
    ],
    treatment: [
      'mask', 'masque', 'clay', 'purifying', 'hydrating mask', 'spot', 'booster', 'ampoule',
      'concentrate', 'treatment', 'serum',
    ],
    eye: ['eye cream', 'eye', 'yeux', 'contour', 'cernes', 'dark circle', 'lash', 'brow'],
    exec: ['multi', 'all-in-one', 'all in one', 'serum', 'cream', 'routine', 'set', 'kit'],
    neck: ['neck', 'décolleté', 'decol', 'firm', 'lift', 'contour', 'jaw', 'cou'],
    hair: ['hair', 'shampoo', 'shampooing', 'conditioner', 'scalp', 'capillaire', 'dry shampoo'],
    body: ['body', 'corps', 'hand cream', 'hand', 'body lotion', 'dry oil', 'deodorant', 'shower'],
  };

  function $(sel, el) { return (el || document).querySelector(sel); }
  function el(tag, cls) { const e = document.createElement(tag); if (cls) e.className = cls; return e; }

  function render(container) {
    const store = container.dataset.store || window.location.host;
    const token = container.dataset.token || '';
    container.innerHTML = '';

    const header = el('div', 'mxz-card');
    header.innerHTML = '<div class="mxz-flex"><div><strong>MEXZY Beauty Scan</strong></div><div class="mxz-muted">On‑device analysis. No upload.</div></div>';
    container.appendChild(header);

    const form = el('div', 'mxz-row');
    form.innerHTML = `
      <div class="mxz-col">
        <div class="mxz-field">
          <label>Gender</label>
          <select class="mxz-select" id="mxz-gender">
            <option value="preferNotToSay">Prefer not to say</option>
            <option value="female">Female</option>
            <option value="male">Male</option>
            <option value="nonbinary">Non‑binary</option>
          </select>
        </div>
      </div>
      <div class="mxz-col">
        <div class="mxz-field">
          <label>Skin type (optional)</label>
          <select class="mxz-select" id="mxz-skin">
            <option value="">Not sure</option>
            <option value="oily">Oily</option>
            <option value="dry">Dry</option>
            <option value="normal">Normal</option>
            <option value="combination">Combination</option>
            <option value="sensitive">Sensitive</option>
          </select>
        </div>
      </div>
      <div class="mxz-col">
        <div class="mxz-field">
          <label>Age range</label>
          <select class="mxz-select" id="mxz-age">
            <option value="18–25">18–25</option>
            <option value="26–35" selected>26–35</option>
            <option value="36–45">36–45</option>
            <option value="46–60">46–60</option>
            <option value=">60">&gt;60</option>
          </select>
        </div>
      </div>
    `;
    container.appendChild(form);

    const preview = el('div', 'mxz-card');
    preview.innerHTML = `
      <div class="mxz-muted">Center your face, ensure good lighting.</div>
      <div class="mxz-videoWrap" style="margin-top:8px;">
        <video id="mxz-video" autoplay playsinline muted></video>
        <div id="mxz-camera-gate" class="mxz-camera-gate">
          <button type="button" class="mxz-button" id="mxz-camera-enable">Turn on camera</button>
          <p class="mxz-muted mxz-camera-gate__hint">Tap to allow camera access in your browser, then center your face.</p>
          <p class="mxz-camera-gate__error mxz-hidden" id="mxz-camera-error"></p>
        </div>
        <div id="mxz-scanfx" class="mxz-scanfx hidden">
          <div class="mxz-scanfx__line"></div>
          <div class="mxz-scanfx__status">
            <div class="mxz-scanfx__progress"><div class="mxz-scanfx__bar"></div></div>
            <div class="mxz-scanfx__text">Scanning... 0%</div>
          </div>
        </div>
      </div>
      <canvas id="mxz-canvas" class="mxz-hidden"></canvas>
    `;
    container.appendChild(preview);

    const actions = el('div', 'mxz-actions');
    actions.innerHTML = `<button class="mxz-button" id="mxz-scan">Scan &amp; Recommend</button>`;
    container.appendChild(actions);
    const results = el('div', '');
    results.innerHTML = `
      <div class="mxz-card" id="mxz-summary">
        <strong>Analysis Summary</strong>
        <div class="mxz-muted">Pigmentation, dark circles, redness, pores, fine lines</div>
        <div id="mxz-spiral" style="margin-top:8px;"></div>
        <div id="mxz-scores" style="margin-top:8px;"></div>
      </div>
      <div class="mxz-card" id="mxz-recos">
        <strong>Recommendations</strong>
        <details class="mxz-collapse"><summary>Easy 3‑step beauty</summary><ul class="mxz-list" id="mxz-easy"></ul></details>
        <details class="mxz-collapse"><summary>Toner &amp; prep</summary><ul class="mxz-list" id="mxz-toner"></ul></details>
        <details class="mxz-collapse"><summary>Day‑time care</summary><ul class="mxz-list" id="mxz-day"></ul></details>
        <details class="mxz-collapse"><summary>Night care</summary><ul class="mxz-list" id="mxz-night"></ul></details>
        <details class="mxz-collapse"><summary>Targeted treatment</summary><ul class="mxz-list" id="mxz-treatment"></ul></details>
        <details class="mxz-collapse"><summary>Eye &amp; lip care</summary><ul class="mxz-list" id="mxz-eye"></ul></details>
        <details class="mxz-collapse"><summary>For executive / fast routine</summary><ul class="mxz-list" id="mxz-exec"></ul></details>
        <details class="mxz-collapse"><summary>Neck / Firming</summary><ul class="mxz-list" id="mxz-neck"></ul></details>
        <details class="mxz-collapse"><summary>Hair care</summary><ul class="mxz-list" id="mxz-hair"></ul></details>
        <details class="mxz-collapse"><summary>Body care</summary><ul class="mxz-list" id="mxz-body"></ul></details>
      </div>
    `;
    container.appendChild(results);

    const video = $('#mxz-video', container);
    const scanBtn = $('#mxz-scan', container);
    const cameraGate = $('#mxz-camera-gate', container);
    const cameraEnable = $('#mxz-camera-enable', container);
    const cameraError = $('#mxz-camera-error', container);
    let cameraPromise = null;

    function cameraLive() {
      return !!(video && video.srcObject && video.srcObject.active && video.readyState >= 2);
    }

    function showCameraError(message) {
      if (!cameraError) return;
      cameraError.textContent = message;
      cameraError.classList.remove('mxz-hidden');
    }

    function hideCameraGate() {
      if (cameraGate) cameraGate.classList.add('mxz-hidden');
      if (cameraError) cameraError.classList.add('mxz-hidden');
    }

    function startCamera() {
      if (cameraLive()) return Promise.resolve(video.srcObject);
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        showCameraError('Camera is not supported in this browser.');
        if (scanBtn) scanBtn.disabled = true;
        return Promise.reject(new Error('unsupported'));
      }
      if (cameraPromise) return cameraPromise;
      if (cameraEnable) cameraEnable.disabled = true;
      cameraPromise = navigator.mediaDevices
        .getUserMedia({ video: { facingMode: 'user' }, audio: false })
        .then((stream) => {
          video.srcObject = stream;
          return video.play().catch(() => {});
        })
        .then(() => {
          hideCameraGate();
          if (cameraEnable) cameraEnable.disabled = false;
          cameraPromise = null;
          return video.srcObject;
        })
        .catch((err) => {
          cameraPromise = null;
          if (cameraEnable) cameraEnable.disabled = false;
          const denied = err && (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError');
          showCameraError(
            denied
              ? 'Camera permission was blocked. Allow camera for this site in browser settings, then tap Turn on camera again.'
              : 'Could not open the camera. Check that no other app is using it, then try again.'
          );
          return Promise.reject(err);
        });
      return cameraPromise;
    }

    if (cameraEnable) {
      cameraEnable.addEventListener('click', () => { startCamera(); });
    }

    $('#mxz-scan', container).addEventListener('click', async () => {
      if (!cameraLive()) {
        try {
          await startCamera();
        } catch {
          return;
        }
      }
      if (!video.videoWidth) {
        showCameraError('Camera is still starting. Wait a moment and tap Scan again.');
        return;
      }
      // Start scanning effect
      const fx = $('#mxz-scanfx', container);
      const bar = $('#mxz-scanfx .mxz-scanfx__bar', container);
      const text = $('#mxz-scanfx .mxz-scanfx__text', container);
      if (fx && bar && text) {
        fx.classList.remove('hidden'); fx.classList.remove('done');
        let p = 0;
        text.textContent = 'Scanning... 0%';
        bar.style.width = '0%';
        const tick = setInterval(() => {
          p = Math.min(92, p + 3);
          bar.style.width = p + '%';
          text.textContent = 'Scanning... ' + p + '%';
        }, 120);
        // Capture + analysis
      const canvas = $('#mxz-canvas', container);
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(video, 0, 0);
      const scores = analyze(canvas);
      renderScores(scores, $('#mxz-scores', container));
      renderSpiral(scores, $('#mxz-spiral', container));
      const groups = await fetchRecommendations(store, token, scores, container);
      fillList($('#mxz-easy', container), groups.easy);
      fillList($('#mxz-toner', container), groups.toner);
      fillList($('#mxz-day', container), groups.day);
      fillList($('#mxz-night', container), groups.night);
      fillList($('#mxz-treatment', container), groups.treatment);
      fillList($('#mxz-eye', container), groups.eye);
      fillList($('#mxz-exec', container), groups.exec);
      fillList($('#mxz-neck', container), groups.neck);
      fillList($('#mxz-hair', container), groups.hair);
      fillList($('#mxz-body', container), groups.body);
        // Finish scanning effect
        clearInterval(tick);
        bar.style.width = '100%';
        fx.classList.add('done');
        text.textContent = 'Analysis complete';
        setTimeout(() => { fx.classList.add('hidden'); }, 600);
      }
      // Expand groups so items are visible even if <details> is disabled by theme CSS/JS
      ['easy','toner','day','night','treatment','eye','exec','neck','hair','body'].forEach(function(id){
        var ul = document.getElementById('mxz-' + id);
        if (ul && ul.parentElement && ul.parentElement.tagName && ul.parentElement.tagName.toLowerCase() === 'details') {
          ul.parentElement.setAttribute('open','open');
        }
      });
      const summaryEl = document.getElementById('mxz-summary');
      if (summaryEl && summaryEl.scrollIntoView) {
        setTimeout(() => { try{ summaryEl.scrollIntoView({behavior:'smooth', block:'start'});}catch(e){} }, 50);
      }
    });
  }

  function analyze(canvas) {
    // Heuristic similar to the Flutter version: compute region stats
    const w = canvas.width, h = canvas.height;
    const ctx = canvas.getContext('2d');
    const full = ctx.getImageData(0, 0, w, h).data;

    function region(x, y, rw, rh) {
      x = Math.max(0, Math.floor(x)); y = Math.max(0, Math.floor(y));
      rw = Math.min(w - x, Math.floor(rw)); rh = Math.min(h - y, Math.floor(rh));
      let sumY = 0, sumY2 = 0, sumR = 0, sumG = 0, sumB = 0, c = 0;
      for (let j = y; j < y + rh; j += 2) {
        for (let i = x; i < x + rw; i += 2) {
          const idx = (j * w + i) * 4;
          const r = full[idx], g = full[idx + 1], b = full[idx + 2];
          const Y = 0.2126 * r + 0.7152 * g + 0.0722 * b;
          sumR += r; sumG += g; sumB += b; sumY += Y; sumY2 += Y * Y; c++;
        }
      }
      const meanY = sumY / Math.max(1, c);
      const varY = Math.max(0, sumY2 / Math.max(1, c) - meanY * meanY);
      const stdY = Math.sqrt(varY);
      return { meanR: sumR / c, meanG: sumG / c, meanB: sumB / c, meanY, stdY };
    }
    const roi = { x: w * 0.2, y: h * 0.15, rw: w * 0.6, rh: h * 0.7 };
    const t = region(roi.x + roi.rw * 0.35, roi.y + roi.rh * 0.1, roi.rw * 0.3, roi.rh * 0.5);
    const u = region(roi.x + roi.rw * 0.1, roi.y + roi.rh * 0.55, roi.rw * 0.8, roi.rh * 0.35);
    const under = region(roi.x + roi.rw * 0.2, roi.y + roi.rh * 0.55, roi.rw * 0.6, roi.rh * 0.2);
    const face = region(roi.x, roi.y, roi.rw, roi.rh);

    const redness = Math.max(0, Math.min(1, (face.meanR - (face.meanG + face.meanB) / 2) / 255));
    const darkCircles = Math.max(0, Math.min(1, (u.meanY - under.meanY) / 100));
    const pores = Math.max(0, Math.min(1, t.stdY / 64));
    const fineLines = Math.max(0, Math.min(1, under.stdY / 64));
    const pigmentation = Math.max(0, Math.min(1, face.stdY / 64));
    return { pigmentation, dark_circles: darkCircles, redness, pores, fine_lines: fineLines };
  }

  function renderScores(scores, host) {
    const entries = Object.entries(scores);
    host.innerHTML = entries.map(([k, v]) =>
      `<span class="mxz-chip">${label(k)}: ${(v * 100).toFixed(0)}%</span> `
    ).join('');
  }

  function renderSpiral(scores, host) {
    const order = ['pigmentation', 'dark_circles', 'redness', 'pores', 'fine_lines'];
    const size = 260, cx = size / 2, cy = size / 2, R = size * 0.42;
    const pts = order.map((k, i) => {
      const v = Math.min(1, Math.max(0, scores[k] || 0));
      const eased = 0.15 + 0.85 * v;
      const ang = (2 * Math.PI / order.length) * i - Math.PI / 2;
      const r = R * eased;
      return [cx + Math.cos(ang) * r, cy + Math.sin(ang) * r];
    });
    const pathD = 'M ' + pts.map(p => p.join(',')).join(' L ') + ' Z';
    host.innerHTML = `
      <svg width="${size}" height="${size}">
        <circle cx="${cx}" cy="${cy}" r="${R*0.2}" fill="none" stroke="#e5e7eb"/>
        <circle cx="${cx}" cy="${cy}" r="${R*0.4}" fill="none" stroke="#e5e7eb"/>
        <circle cx="${cx}" cy="${cy}" r="${R*0.6}" fill="none" stroke="#e5e7eb"/>
        <circle cx="${cx}" cy="${cy}" r="${R*0.8}" fill="none" stroke="#e5e7eb"/>
        <circle cx="${cx}" cy="${cy}" r="${R}" fill="none" stroke="#e5e7eb"/>
        <path d="${pathD}" fill="url(#g1)" stroke="#26C6DA" stroke-width="2"/>
        <defs>
          <linearGradient id="g1" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stop-color="#2196F3" stop-opacity="0.2"/>
            <stop offset="100%" stop-color="#26C6DA" stop-opacity="0.2"/>
          </linearGradient>
        </defs>
      </svg>
    `;
  }

  function label(k) {
    switch (k) {
      case 'pigmentation': return 'Pigment';
      case 'dark_circles': return 'Dark Circles';
      case 'redness': return 'Redness';
      case 'pores': return 'Pores';
      case 'fine_lines': return 'Fine Lines';
      default: return k;
    }
  }

  // Build personalized keyword sets using scan issues and selected skin type
  function getSelectedSkin() {
    const el = document.getElementById('mxz-skin');
    return el && typeof el.value === 'string' ? el.value : '';
  }

  function getSelectedAge() {
    const el = document.getElementById('mxz-age');
    return el && typeof el.value === 'string' ? el.value : '';
  }

  function getSelectedGender() {
    const el = document.getElementById('mxz-gender');
    return el && typeof el.value === 'string' ? el.value : '';
  }

  function uniq(arr) {
    const out = [];
    const seen = new Set();
    for (const v of arr) {
      const k = String(v || '').trim().toLowerCase();
      if (!k) continue;
      if (!seen.has(k)) { seen.add(k); out.push(k); }
    }
    return out;
  }

  function aliasExpand(list) {
    const aliases = {
      moisturizer: ['moisturiser', 'crème', 'creme'],
      moistur: ['moisturiser', 'moisturizer', 'hydrat'],
      cleanser: ['cleansing', 'wash', 'gel nettoyant'],
      serum: ['sérum', 'concentrate', 'booster'],
      'vitamin c': ['vit c', 'ascorbic', 'brightening'],
      bha: ['salicylic', 'salicylique'],
      aha: ['glycolic', 'lactic', 'aha'],
      retinol: ['retinoid', 'retinal'],
      'non-comedogenic': ['non comedogenic', 'noncomedogenic'],
      sunscreen: ['spf', 'sun screen', 'sun care'],
      peptide: ['peptides', 'peptid'],
      ceramide: ['ceramides'],
      toner: ['tonique', 'lotion'],
      mask: ['masque'],
      eye: ['yeux', 'contour des yeux'],
      hair: ['capillaire', 'cheveux'],
      body: ['corps'],
      oil: ['huile', 'dry oil'],
    };
    const out = [];
    for (const term of list || []) {
      out.push(term);
      const key = String(term || '').toLowerCase();
      const extra = aliases[key];
      if (extra && extra.length) out.push(...extra);
    }
    return uniq(out);
  }

  function expandGroupKeywords(groups) {
    const out = {};
    for (const key of Object.keys(groups || {})) {
      out[key] = aliasExpand(groups[key] || []);
    }
    return out;
  }

  function buildPersonalizedKeywords(scores, skin, age, gender) {
    const pairs = Object.entries(scores || {}).sort((a, b) => (b[1] || 0) - (a[1] || 0));
    const topIssues = pairs.map(p => p[0]).slice(0, 4);

    const issueMap = {
      pigmentation: [
        'brighten', 'dark spot', 'vitamin c', 'niacinamide', 'tranexamic', 'alpha arbutin',
        'radiance', 'glow', 'hyperpigmentation', 'even tone',
      ],
      redness: [
        'soothing', 'calming', 'azelaic', 'centella', 'cica', 'allantoin', 'barrier',
        'redness', 'sensitive', 'repair',
      ],
      dark_circles: [
        'eye cream', 'eye serum', 'caffeine', 'niacinamide', 'retinol eye', 'contour',
        'cernes', 'dark circle',
      ],
      pores: [
        'salicylic', 'bha', 'pore', 'niacinamide', 'clay', 'purifying', 'mattifying',
        'blackhead', 'sebum',
      ],
      fine_lines: [
        'retinol', 'peptide', 'bakuchiol', 'hyaluronic', 'ceramide', 'anti-age', 'wrinkle',
        'firming', 'collagen',
      ],
    };
    const skinMap = {
      oily: ['oil control', 'gel', 'lightweight', 'non-comedogenic', 'mattifying'],
      dry: ['moisturizer', 'cream', 'hydrating', 'hyaluronic', 'ceramide', 'shea'],
      normal: ['balanced', 'moisturizer'],
      combination: ['balancing', 'lightweight', 'gel cream'],
      sensitive: ['fragrance free', 'soothing', 'cica', 'centella', 'barrier', 'hypoallergenic'],
    };

    const genderBoost = {
      male: ['men', 'beard', 'after shave'],
      female: ['makeup remover', 'démaquillant', 'lip'],
      nonbinary: [],
      preferNotToSay: [],
    };

    const ageMap = {
      '18–25': ['gentle', 'gel', 'niacinamide', 'sunscreen'],
      '26–35': ['niacinamide', 'hyaluronic', 'sunscreen'],
      '36–45': ['peptide', 'retinol', 'hyaluronic', 'ceramide', 'firming'],
      '46–60': ['peptide', 'retinol', 'ceramide', 'firming', 'lifting'],
      '>60': ['peptide', 'retinoid', 'ceramide', 'firming', 'lifting', 'rich cream']
    };

    function mix(base, group) {
      const arr = [];
      if (Array.isArray(base)) arr.push(...base);
      const ageTerms = ageMap[age] || [];
      // For day/night, emphasize issue-derived terms immediately after base
      if (group === 'day' || group === 'night') {
        // Age terms early for daytime/nighttime regimens
        if (ageTerms.length) arr.push(...ageTerms);
        for (const issue of topIssues) arr.push(...(issueMap[issue] || []));
      }
      if (skinMap[skin]) arr.push(...skinMap[skin]);
      // For other groups, append issue-derived terms later
      if (group !== 'day' && group !== 'night') {
        if (ageTerms.length) arr.push(...ageTerms);
        for (const issue of topIssues) arr.push(...(issueMap[issue] || []));
      }
      // Add explicit "for <skin> skin" variants near the end (if present)
      if (skin) arr.push(`for ${skin} skin`, `${skin} skin`);
      const gTerms = genderBoost[gender] || [];
      if (gTerms.length) arr.push(...gTerms);
      return uniq(arr).slice(0, MAX_KEYWORDS_PER_GROUP);
    }

    const treatmentBase = ['mask', 'masque', 'serum', 'treatment', 'booster'];
    if (topIssues.includes('pores') || skin === 'oily') treatmentBase.unshift('clay', 'purifying');
    if (topIssues.includes('fine_lines') || (age && age !== '18–25')) treatmentBase.push('peptide', 'retinol');
    if (topIssues.includes('redness') || skin === 'sensitive') treatmentBase.push('soothing', 'cica');

    return {
      easy: mix(['cleanser', 'serum', 'moisturizer', 'essence', 'lotion', 'cleansing oil'], 'easy'),
      toner: mix(['toner', 'tonique', 'essence', 'mist', 'hydrating lotion', 'prep'], 'toner'),
      day: mix(['sunscreen', 'spf', 'vitamin c', 'brighten', 'day cream', 'fluid', 'antioxidant'], 'day'),
      night: mix(['retinol', 'peptide', 'night cream', 'repair', 'sleeping mask', 'balm', 'bakuchiol', 'oil'], 'night'),
      treatment: mix(treatmentBase, 'treatment'),
      eye: mix(['eye cream', 'eye serum', 'contour', 'lip balm', 'cernes'], 'eye'),
      exec: mix(['all-in-one', 'multi', 'serum', 'cream', 'set', 'routine kit'], 'exec'),
      neck: mix(['neck', 'décolleté', 'firm', 'lift', 'contour', 'jaw'], 'neck'),
      hair: mix(['shampoo', 'conditioner', 'hair mask', 'scalp', 'hair oil'], 'hair'),
      body: mix(['body lotion', 'hand cream', 'body oil', 'shower gel', 'deodorant'], 'body'),
    };
  }

  let catalogLoadPromise = null;

  function parseProductTags(raw) {
    if (Array.isArray(raw)) return raw.map((t) => String(t).trim().toLowerCase()).filter(Boolean);
    return String(raw || '')
      .split(',')
      .map((t) => t.trim().toLowerCase())
      .filter(Boolean);
  }

  function scanGroupsFromTags(tags) {
    const set = new Set();
    for (const t of tags) {
      if (t === TAG_ANY) SCAN_GROUP_NAMES.forEach((g) => set.add(g));
      else if (t.startsWith(TAG_PREFIX) && t !== TAG_EXCLUDE) set.add(t.slice(TAG_PREFIX.length));
    }
    return set;
  }

  function minVariantPriceFromAjax(variants) {
    let min = null;
    for (const v of variants || []) {
      const p = parseFloat(v.price);
      if (!Number.isFinite(p)) continue;
      if (min == null || p < min) min = p;
    }
    return min != null ? min.toFixed(2) : '';
  }

  function normalizeCatalogRow(p) {
    const tags = parseProductTags(p.tags);
    const searchText =
      p.searchText ||
      [p.title, p.product_type, p.vendor, tags.join(' ')]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();
    return {
      handle: p.handle,
      name: p.title,
      url: `/products/${p.handle}`,
      vendor: p.vendor || '',
      product_type: p.product_type || '',
      tags,
      price: p.price || '',
      searchText,
      scanGroups: scanGroupsFromTags(tags),
    };
  }

  async function loadCatalogFromCollectionPages() {
    const all = [];
    for (let page = 1; page <= 40; page += 1) {
      const res = await fetch(`/collections/all/products.json?limit=250&page=${page}`, {
        credentials: 'same-origin',
      });
      if (!res.ok) break;
      const data = await res.json();
      const batch = data.products || [];
      if (!batch.length) break;
      for (const p of batch) {
        all.push(
          normalizeCatalogRow({
            handle: p.handle,
            title: p.title,
            vendor: p.vendor,
            product_type: p.product_type,
            tags: parseProductTags(p.tags),
            price: minVariantPriceFromAjax(p.variants),
          })
        );
      }
      if (batch.length < 250) break;
    }
    return all;
  }

  async function loadProductCatalog(rootEl) {
    if (window.__mxzProductCatalog && window.__mxzProductCatalog.length) {
      return window.__mxzProductCatalog;
    }
    if (catalogLoadPromise) return catalogLoadPromise;

    catalogLoadPromise = (async () => {
      const assetUrl = rootEl && rootEl.dataset ? rootEl.dataset.catalogUrl : '';
      if (assetUrl) {
        try {
          const res = await fetch(assetUrl, { credentials: 'same-origin' });
          if (res.ok) {
            const json = await res.json();
            if (json && Array.isArray(json.products) && json.products.length) {
              window.__mxzProductCatalog = json.products.map(normalizeCatalogRow);
              return window.__mxzProductCatalog;
            }
          }
        } catch {
          /* use collection fallback */
        }
      }
      window.__mxzProductCatalog = await loadCatalogFromCollectionPages();
      return window.__mxzProductCatalog;
    })();

    return catalogLoadPromise;
  }

  function scoreProductForGroup(product, groupName, keywords) {
    if (product.tags.includes(TAG_EXCLUDE)) return -1;
    let score = 0;
    if (product.scanGroups.has(groupName)) score += 2000;
    for (let i = 0; i < keywords.length; i += 1) {
      const k = String(keywords[i] || '').toLowerCase();
      if (!k) continue;
      if (product.searchText.includes(k)) score += (keywords.length - i) * 5;
    }
    return score;
  }

  function toDisplayItem(p) {
    return { name: p.name, url: p.url, price: p.price, handle: p.handle };
  }

  function pickFromCatalog(catalog, groupName, keywords, usedUrls) {
    const list = uniq(keywords || []);
    const ranked = catalog
      .map((p) => ({ p, score: scoreProductForGroup(p, groupName, list) }))
      .filter((x) => x.score >= 0)
      .sort((a, b) => b.score - a.score);

    const pick = [];
    for (const { p } of ranked) {
      if (usedUrls.has(p.url)) continue;
      pick.push(toDisplayItem(p));
      usedUrls.add(p.url);
      if (pick.length >= RECO_PER_GROUP) break;
    }

    if (pick.length < RECO_PER_GROUP) {
      for (const p of catalog) {
        if (p.tags.includes(TAG_EXCLUDE)) continue;
        if (usedUrls.has(p.url)) continue;
        pick.push(toDisplayItem(p));
        usedUrls.add(p.url);
        if (pick.length >= RECO_PER_GROUP) break;
      }
    }
    return pick;
  }

  // Full-catalog match first; predictive search is fallback if catalog cannot load
  async function fetchRecommendations(_store, _token, _scores, rootEl) {
    const suggestCache = new Map();

    async function suggest(keyword, limit = SUGGEST_LIMIT) {
      const q = String(keyword || '').trim();
      if (!q) return [];
      const cacheKey = q.toLowerCase();
      if (suggestCache.has(cacheKey)) return suggestCache.get(cacheKey);

      const url =
        `/search/suggest.json?q=${encodeURIComponent(q)}` +
        `&resources[type]=product&resources[limit]=${limit}` +
        '&resources[options][unavailable_products]=hide';

      const promise = (async () => {
        try {
          const res = await fetch(url, {
            method: 'GET',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            credentials: 'same-origin',
          });
          if (!res || !res.ok) return [];
          const json = await res.json();
          const items = (((json || {}).resources || {}).results || {}).products || [];
          return items.map((p) => {
            let price = '';
            if (typeof p.price === 'number') {
              try { price = (p.price / 100).toFixed(2); } catch (e) { price = String(p.price); }
            } else if (typeof p.price === 'string') {
              price = p.price;
            }
            return { name: p.title, url: p.url, price, handle: p.handle || '' };
          });
        } catch {
          return [];
        }
      })();

      suggestCache.set(cacheKey, promise);
      return promise;
    }

    async function searchProductsHtml(keyword, limit = SUGGEST_LIMIT) {
      const q = String(keyword || '').trim();
      if (!q) return [];
      try {
        const res = await fetch(
          `/search?q=${encodeURIComponent(q)}&type=product&options[prefix]=last`,
          { credentials: 'same-origin', headers: { Accept: 'text/html' } }
        );
        if (!res.ok) return [];
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const links = [...doc.querySelectorAll('a[href*="/products/"]')];
        const seen = new Set();
        const out = [];
        for (const a of links) {
          const href = a.getAttribute('href') || '';
          if (!href.includes('/products/') || seen.has(href)) continue;
          seen.add(href);
          const name = (a.textContent || '').trim();
          if (!name || name.length < 2) continue;
          out.push({ name, url: href.startsWith('http') ? href : href, price: '', handle: '' });
          if (out.length >= limit) break;
        }
        return out;
      } catch {
        return [];
      }
    }

    async function collectForGroup(keywords, usedUrls) {
      const list = uniq(keywords || []).slice(0, MAX_KEYWORDS_PER_GROUP);
      const scored = new Map();

      async function scoreKeyword(k, priorityIndex) {
        let items = await suggest(k, SUGGEST_LIMIT);
        if (!items.length) items = await searchProductsHtml(k, SUGGEST_LIMIT);
        items.forEach((item, idx) => {
          const key = item.url || item.name;
          if (!key) return;
          const title = String(item.name || '').toLowerCase();
          const kw = k.toLowerCase();
          let bonus = 0;
          if (title.includes(kw)) bonus += 8;
          const prev = scored.get(key) || { item, score: 0 };
          prev.score += (list.length - priorityIndex) * 3 + (SUGGEST_LIMIT - idx) + bonus;
          scored.set(key, prev);
        });
      }

      for (let i = 0; i < list.length; i += 4) {
        const batch = list.slice(i, i + 4);
        await Promise.all(batch.map((k, j) => scoreKeyword(k, i + j)));
      }

      let ranked = [...scored.values()].sort((a, b) => b.score - a.score).map((x) => x.item);
      const fresh = [];
      for (const item of ranked) {
        if (usedUrls.has(item.url)) continue;
        fresh.push(item);
        if (fresh.length >= RECO_PER_GROUP) break;
      }
      if (fresh.length < RECO_PER_GROUP) {
        for (const item of ranked) {
          if (fresh.find((f) => f.url === item.url)) continue;
          fresh.push(item);
          if (fresh.length >= RECO_PER_GROUP) break;
        }
      }
      fresh.forEach((p) => { if (p.url) usedUrls.add(p.url); });
      return fresh;
    }

    const skin = getSelectedSkin();
    const age = getSelectedAge();
    const gender = getSelectedGender();
    const dynamic = expandGroupKeywords(buildPersonalizedKeywords(_scores, skin, age, gender));
    const usedUrls = new Set();
    const groupNames = SCAN_GROUP_NAMES;
    const out = {};

    const catalog = await loadProductCatalog(rootEl);
    if (catalog.length) {
      for (const name of groupNames) {
        const keywords = uniq([...(dynamic[name] || []), ...(SEARCH_KEYWORDS[name] || [])]);
        out[name] = pickFromCatalog(catalog, name, keywords, usedUrls);
      }
      return out;
    }

    for (const name of groupNames) {
      const keywords = uniq([...(dynamic[name] || []), ...(SEARCH_KEYWORDS[name] || [])]);
      out[name] = await collectForGroup(keywords, usedUrls);
    }
    return out;
  }

  function fillList(ul, items) {
    if (!items || !items.length) {
      ul.innerHTML = `<li class="mxz-muted">No matches yet. Adjust keywords or ensure products are searchable.</li>`;
      return;
    }
    ul.innerHTML = items.map(function(i){
      var price = i.price ? `<span class="mxz-muted">• ${escapeHtml(i.price)}</span>` : '';
      return `<li><span>${escapeHtml(i.name)} ${price}</span><a class="mxz-link" href="${i.url}" target="_blank" rel="noopener">Open</a></li>`;
    }).join('');
  }

  function escapeHtml(s) { return s.replace(/[&<>"']/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m])); }

  document.addEventListener('DOMContentLoaded', () => {
    const root = document.getElementById(ROOT_ID);
    if (root) render(root);
  });
})();
